import { List, useGetList } from "react-admin";
import { Typography } from "@mui/material";
import { useAutovioContext } from "../../hooks/useAutovioContext";
import { SearchFilterInput } from "../../inputs/SearchFilterInput";
import { VehiclesDataGrid, type VehicleListResource } from "./VehiclesDataGrid";
import { ResponsiveListSurface } from "../../misc/ResponsiveListSurface";

export function DeletedVehiclesList({ resource, title }: { resource: VehicleListResource; title: string }) {
  const [{ drivingSchoolId }] = useAutovioContext();
  const filter = { drivingSchoolId, deleted: true };
  const { data } = useGetList(resource, { filter, meta: { source: "server" } }, { enabled: !!drivingSchoolId });

  if (!drivingSchoolId || !data || data.length === 0) {
    return null;
  }

  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ margin: "30px 0 30px 16px", lineHeight: 0.83 }}>
        {title}
      </Typography>
      <ResponsiveListSurface variant="compactStandalone">
        <List
          storeKey={`DeletedVehiclesList-${resource}`}
          title=" " // <-- prevent that the default list title is rendered
          resource={resource}
          // Do not read the vehicles from the Firestore driving_schools document, because the projection
          // into this document might not be in sync with the Postgres database yet (e.g. after a vehicle
          // has been deleted or restored) ...
          queryOptions={{ meta: { source: "server" } }}
          filter={filter}
          filters={[<SearchFilterInput key="q" source="q" alwaysOn resettable />]}
          sort={/* initial sort order: */ { field: "name", order: "ASC" }}
          exporter={false}
          hasCreate={false}
          actions={false}
          disableSyncWithLocation
        >
          <VehiclesDataGrid resource={resource} variant="deleted" empty={<div />} />
        </List>
      </ResponsiveListSurface>
    </>
  );
}
